// const APIURL = "http://localhost:8000";
const APIURL = "https://dev.watfordconsulting.com/contractor-induction-backend";
const axios = require("axios");

export const sendEmail = data => {

    return axios.post(`${APIURL}/email/send`, data);

}